import { TablePattern } from 'src/app/models/table-patterns';
import { Entity } from 'src/app/models/entities.model';
import { Document } from 'src/app/features/documents/models/document.models';
// tslint:disable: variable-name

export interface ValidationFields {
  photo_url: boolean;
  name: boolean;
  document: boolean;
  document_foreigner: boolean;
  birth: boolean;
  rg?: boolean;
}


export class ValidationRejection {
  type: 'F' | 'D' | 'M';
  target_id?: number;
  field?: string;
  reason: string;

  typeName?: string;

  constructor(o: ValidationRejection) {
    Object.assign(this, o);
    switch (this.type) {
      case 'D': this.typeName = 'Documento'; break;
      case 'F': this.typeName = 'Campo'; break;
      case 'M': this.typeName = 'Mensagem'; break;
      default: this.typeName = 'Outros'; break;
    }
  }
}

export class EntityValidation extends TablePattern {
  validated_id: number;
  user_id: number;
  uid: string;
  validated_data: ValidationFields;
  behalf_id: number;
  documents_ids: number[];
  validated: boolean;
  rejections: ValidationRejection[];
  message: string;
  validation_expires: string;

  behalf?: Entity;
  user?: Entity;
  documents?: Document[];

}


export interface ValidationAprovalRequest {
  validationType: 'aprove' | 'reject';
  fieldsToUpdate: Partial<Entity>;
  validatedDocuments: number[];
  validatedFields: ValidationFields;
  rejections: ValidationRejection[];
  message?: string;
}


